// Opera 8.0+
var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
// Firefox 1.0+
var isFirefox = typeof InstallTrigger !== 'undefined';
// At least Safari 3+: "[object HTMLElementConstructor]"
var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
// Internet Explorer 6-11
var isIE = /*@cc_on!@*/false || !!document.documentMode;
// Edge 20+
var isEdge = !isIE && !!window.StyleMedia;
// Chrome 1+
var isChrome = !!window.chrome && !!window.chrome.webstore;
// Blink engine detection
var isBlink = (isChrome || isOpera) && !!window.CSS;


var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
var is_safari = navigator.userAgent.indexOf("Safari") > -1;
var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
if ((is_chrome) && (is_safari)) {
    is_safari = false;
}
if ((is_chrome) && (is_opera)) {
    is_chrome = false;
}

/*Detect Mobile*/
var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows());
    }
};


capitalizeFirstLetter = function (string) {
    if (string == null) {
        return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
};

mapToArray = function (map) {
    let final = [];
    for (let key in map) {
        final.push(map[key]);
    }
    return final.flattenArray();
};


String.prototype.toShortHHMMSS = function (prependZeros) {
    if (prependZeros == null) {
        prependZeros = true;
    }
    var sec_num = parseInt(this, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10 && prependZeros) {
        hours = "0" + hours;
    }
    if (minutes < 10 && (prependZeros || hours > 0)) {
        minutes = "0" + minutes;
    }
    if (seconds < 10 && (prependZeros || minutes > 0)) {
        seconds = "0" + seconds;
    }
    return hours == 0 ? minutes + ':' + seconds : hours + ':' + minutes + ':' + seconds;
};

String.prototype.toMusicShortHHMMSS = function (prependZeros) {
    if (prependZeros == null) {
        prependZeros = true;
    }
    var sec_num = parseInt(this, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (minutes < 10 && hours > 0 && (prependZeros || hours > 0)) {
        minutes = "0" + minutes;
    }
    if (seconds < 10 && (prependZeros || minutes > 0)) {
        seconds = "0" + seconds;
    }
    return hours == 0 ? minutes + ':' + seconds : hours + ':' + minutes + ':' + seconds;
};

String.prototype.toMusicScreenReadableDuration = function (prependZeros) {
    if (prependZeros == null) {
        prependZeros = true;
    }
    var sec_num = parseInt(this, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (minutes < 10 && hours > 0 && (prependZeros || hours > 0)) {
        minutes = "0" + minutes;
    }
    if (seconds < 10 && (prependZeros || minutes > 0)) {
        seconds = "0" + seconds;
    }
    return hours == 0 ? minutes + ' minutes, ' + seconds + ' seconds': hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds';
};


String.prototype.stringToMS = function () {
    var hms = this.split(':');
    var milliSeconds = ((+hms[0]) * 60 * 60 + (+hms[1]) * 60 + (+hms[2])) * 1000;
    return milliSeconds;
};

function extend(obj, src) {
    for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
    }
    return obj;
}

function isEmpty(str) {
    return str == null || str == "";
}

function isEmail(str) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(str);
}

function isValidLength(str, minPasswordLength) {
    if (minPasswordLength == null) {
        minPasswordLength = 4;
    }
    if (isEmpty(str)) {
        return false;
    }
    return str.length >= minPasswordLength;
}

function safeApply(scope, fn) {
    if (!scope.$root) {
        return;
    }
    var phase = scope.$root.$$phase;
    if (phase === '$apply' || phase === '$digest') {
        if (fn && (typeof (fn) === 'function')) {
            fn();
        }
    } else {

        try {
            scope.$apply(fn);
        } catch (e) {
            // getFactory("Logger").error(e);
        }
    }
}

function safeDigest(scope, fn) {
    if (!scope.$root) {
        return;
    }
    var phase = scope.$root.$$phase;
    if (phase == '$apply' || phase == '$digest') {
        if (fn && (typeof (fn) === 'function')) {
            fn();
        }
    } else {
        scope.$digest(fn);
    }
}

function imgCreate(src) {
    var img = document.createElement('img');
    img.src = src;
    return img;
}

/*Disable Scrolling*/

var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

function disableScroll() {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove = preventDefault; // mobile
    document.onkeydown = preventDefaultForScrollKeys;
}

function enableScroll() {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
}

function shuffleArray(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}

/*Paging*/

function getDefaultPagination(pageSize, pageNumber, desc, countTotalResults, sortField) {
    if (pageSize == null) {
        pageSize = 40;
    }

    if (pageNumber == null) {
        pageNumber = 1;
    }

    if (desc == null) {
        desc = false;
    }

    if (countTotalResults == null) {
        countTotalResults = false;
    }

    var newVar = {
        countTotalResults: countTotalResults,
        descending: desc,
        pageNumber: pageNumber,
        pageSize: pageSize
    };

    if (sortField != null) {
        newVar.sortField = sortField;
    }

    return newVar;
}

/*Date Parser*/

getFullDate = function (dateData) {
    var d = new Date(dateData);
    return " " + (d.getMonth() + 1) + "-" + d.getDate() + "-" + d.getFullYear();
};

getStringDate = function (dateData) {
    var d = new Date(dateData);
    return getStringMonth(d.getMonth() + 1) + ' ' + d.getDate() + ', ' + d.getFullYear();
};

getStringMonth = function (monthNumber) {
    var b = '';
    switch (monthNumber) {
        case 1:
            b = "Jan.";
            break;
        case 2:
            b = "Feb.";
            break;
        case 3:
            b = "Mar.";
            break;
        case 4:
            b = "Apr.";
            break;
        case 5:
            b = "May";
            break;
        case 6:
            b = "June";
            break;
        case 7:
            b = "July";
            break;
        case 8:
            b = "Aug.";
            break;
        case 9:
            b = "Sept.";
            break;
        case 10:
            b = "Oct.";
            break;
        case 11:
            b = "Nov.";
            break;
        case 12:
            b = "Dec.";
            break;
    }
    return b;
};

/*Setup Cover Images*/

getCoverStyleBackground = function (url) {
    return {
        'background-image': 'url(' + url + ')',
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'background-size': 'cover'
    };
};

String.prototype.toHHMMSS = function () {
    var sec_num = parseInt(this, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);
    return {hours: hours, minutes: minutes, seconds: seconds};
};

String.prototype.toShortPreffixHHMMSS = function () {
    var sec_num = parseInt(this, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);
    return {hr: hours, min: minutes, sec: seconds};
};

/*Preload Images*/

preloadImage = function (url, altText, callbackFunc) {
    var img = new Image();
    img.src = url;
    img.onload = function () {
        if (callbackFunc != null) {
            callbackFunc(url, altText);
        }
    }
};

getInjector = function () {
    if (location.href.indexOf('emusic.com') !== -1) {
        return angular.element($("#global__wrapper")).injector();
    }
    return angular.element($("[ng-app]:first")[0]).injector();
};

getFactory = function (factoryName) {
    return getInjector().get(factoryName);
};

booleanEmoji = function (bool) {
    return bool ? "✔️" : "❌ "
};

isResponseSuccess = function (res) {
    return res && res.responseStatus === 'SUCCESS';
};